import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SamlSignOnComponent } from './components/saml-signon/saml-signon.component';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { AddUsersComponent } from './components/add-users/add-users.component';
import { CeleryTaskViewComponent } from './components/celery-task-view/celery-task-view.component';
import { DocumentationComponent } from './components/documentation/documentation.component';

const routes: Routes = [
  {
    path: 'saml-login',
    component: SamlSignOnComponent,
  },
  {
    path: 'manage-users',
    component: UserManagementComponent,
  },
  {
    path: 'add-users',
    component: AddUsersComponent,
  },
  {
    path: 'tasks',
    component: CeleryTaskViewComponent,
  },
  {
    path: 'documentation',
    component: DocumentationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
